import { useEffect } from 'react';

export interface SeoOptions {
  title: string;
  description: string;
  keywords?: string;
  path?: string;
  type?: string;
  structuredData?: Record<string, unknown> | Record<string, unknown>[];
}

const BASE_URL = 'https://xinnanwangluo.cn';

export function usePageSeo({
  title,
  description,
  keywords,
  path = '/',
  type = 'website',
  structuredData,
}: SeoOptions) {
  const structuredKey = structuredData ? JSON.stringify(structuredData) : '';

  useEffect(() => {
    document.title = title;

    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    const canonical = `${BASE_URL}${path === '/' ? '/' : path}`;

    setMeta('name', 'description', description);
    if (keywords) {
      setMeta('name', 'keywords', keywords);
    }
    setMeta('property', 'og:type', type);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', canonical);
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', canonical);

    let script: HTMLScriptElement | null = null;
    if (structuredKey) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-page-seo', 'true');
      script.textContent = structuredKey;
      document.head.appendChild(script);
    }

    return () => {
      if (script && script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [title, description, keywords, path, type, structuredKey]);
}